define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/xml",
	"ProductSpec/SizeChart/Revised"
], function(declare,heading,xml,Revised) {

	return declare(Revised, {
		cssBaseSize: " tableSizeChartPatternRevisedBase",
		cssOffBaseSize: " tableSizeChartPatternRevised",
		idOriginal: "Pattern",
		idRevised: "RevisedPattern"
	});
});